<template>
  <div class="page-container representation-container">
    <section class="representation-content">
      <article v-if="state.showPricing">
        <div class="row justify-content-md-center pt-4">
          <div class="col-md-8 mb-3 mt-3">
            <span class="text-center proposal-title" for="">
              <strong>Premium Proposal for: </strong> <span class=" blue-color"> {{ ppiApplication.nameOfApplicant }}</span>
            </span>
          </div>
          <div class="col-md-8 mb-3">
            <span class="col-md-4 text-center proposal-title pl-0 pr-0" for="">
              <strong>Limits of Coverage: </strong>
            <span class=" blue-color"> {{ coverage() }}</span>
            </span>
          </div>

            <div class="col-md-8 mb-3">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                      type="checkbox"
                      name="cyberTechnologyCoverage"
                      value="300K/600K"
                      class="orep-radio"
                      v-model="ppiApplication.cyberTechnologyCoverage"
                      @change="totalAfterCyberTechnologyCoverage(coverages)"
                  >
                  <span class="radio-span solo-checkbox-span cyber-technology-coverage-title">Add $100,000 of
                    <a href="https://orep.org/100K-cyber-coverage-pi" target="_blank" class="coverage-link">
                      Cyber / Technology Security Coverage</a> for just $125 </span>
                </label>
              </div>
            </div>

        </div>
        <div class="row pt-5 mb-5 input-section">
          <h2 class="text-center font-weight-bold mx-auto">
            This Quote includes E&O and General Liability in ONE Policy:
          </h2>
        </div>
        <div class="row mr-0 ml-0">
          <div class="col-md-7">
            <div class="text-center mr-5 pull-left ">
              <p class="mr-0 representation-price-font-active">{{ coverages[state.coverage].total }}</p>
              <span class="blue-color mb-0">Total - Pay in Full</span>
            </div>
            <button class="pull-right pay-now" @click="payNow(dollarSlicing(coverages[state.coverage].total))">PAY NOW</button>
          </div>
          <div class="col-md-5  quote-includes-btn-wrapper flex align-items-center justify-content-md-center">
            <button
              class="orep-select quote-include"
              name="state"
              v-validate="'required'"
            >
              Quote Includes
            </button>
          </div>
        </div>
        <div class="row quote-action quote-include-action-wrapper input-section mr-0 ml-0">
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title">Premium:</span>
                <span>{{ coverages[state.coverage].premium }}</span>
              </li>
              <li>
                <span class="title"> State SL Tax:</span>
                <span>{{ coverages[state.coverage].surplusLineTax }}</span>
              </li>
              <li>
                <span class="title"> State Stamping Fee:</span>
                <span>{{ coverages[state.coverage].stampingFee }}</span>
              </li>
              <li>
                <span class="title">OREP Fee:  </span>
                <span>{{ coverages[state.coverage].orepFee }}</span>
              </li>
              <li>
                <span class="title">Extra Fee:</span>
                <span>{{ coverages[state.coverage].extraFee }}</span>
              </li>
              <li>
                <span class="title">Association Discount:</span>
                <span>-{{ coverages[state.coverage].discount }}</span>
              </li>
              <li v-if="ppiApplication.cyberTechnologyCoverage">
                <span class="title">Cyber :</span>
                <span>{{ coverages[state.coverage].premiumCyberTechnologyCoverage }}</span>
              </li>
              <li class="total">
              <span class="title">Total:</span>
                <h5 class="font-weight-bold m-0">{{ coverages[state.coverage].total }}</h5>
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title">General Aggregate Limit: </span>
                <span>{{ coverage_second_part() }}</span>
              </li>
              <li>
                <span class="title">Personal & Advertising Limit:</span>
                <span>{{ coverage_first_part() }}</span>
              </li>
              <li>
                <span class="title">Each Occurrence Limit:</span>
                <span>{{ coverage_first_part() }}</span>
              </li>
              <li>
                <span class="title">Damage to Premises Rented to You:</span>
                <span>$100,000</span>
              </li>
              <li>
                <span class="title">Business Personal Property:</span>
                <span>$25,000</span>
              </li>
              <li>
                <span class="title">Equipment Coverage:</span>
                <span>$15,000</span>
              </li>
<!--              <li>-->
<!--                <span class="title">-->
<!--                  Computer Coverage:-->
<!--                </span>-->
<!--                <span>$5,000</span>-->
<!--              </li>-->
            </ul>
          </div>
        </div>
        <div class="row mr-0 ml-0  text-center" style="border:1px solid #ccc">
          <div class="col-md-7">
            <div class="text-center mr-5 pull-left">
              <p class="representation-price-font-disable">{{ coverages[state.coverage].downTotal }}</p>
              <span style="font-size:19px;position:relative;top:-12px;" class="blue-color">Down Payment</span>
              <br><span style="top:-22px;position:relative;font-size: 11px;" class="blue-color">Finance  Your Policy - Finance Charge Applies</span>
            </div>
            <!--            <a v-if="getApplicantType==='Ermunro'" target="_blank" v-bind:href="'https://orep.org/financehudson30-ermunro/index.php?name='+ ppiApplication.nameOfApplicant+'&ia_name='+ppiApplication.customer.contactName+'&address='+encodeURIComponent(ppiApplication.customer.address)+'&city='+ppiApplication.customer.city+'&state_code='+ppiApplication.customer.state+'&zip='+ppiApplication.customer.zipCode+'&phone='+ppiApplication.customer.phone+'&email='+ppiApplication.customer.email+'&date='+getEffectiveDate()+'&premium='+dollarSlicing(coverages[state.coverage].totalWithoutOrepFee)+'&orep_fee='+feeAfterDiscount(coverages[state.coverage].orepFee,coverages[state.coverage].discount)" class="pull-right pay-now_1">PAY NOW</a>-->

            <a v-if="ppiApplication.cyberTechnologyCoverage === false"
               v-bind:href="this.state.requestFinancingPaymentLinkWithOutCyberTechnology"
               target="_blank"
               class="pull-right pay-now_1">PAY NOW</a>

            <a v-else-if="ppiApplication.cyberTechnologyCoverage === true"
               v-bind:href="this.state.requestFinancingPaymentLinkWithCyberTechnology"
               target="_blank"
               class="pull-right pay-now_1">PAY NOW</a>
          </div>
          <div class="col-md-5 quote-includes-btn-wrapper flex align-items-center justify-content-md-center">
            <button
              class="orep-select quote-include_1"
              name="state"
              v-validate="'required'"
            >
              Quote Includes
            </button>
          </div>
        </div>
        <div class="row quote-action quote-include_1-action-wrapper input-section mr-0 ml-0">
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title">Premium:</span>
                <span>{{ coverages[state.coverage].premium }}</span>
              </li>
              <li>
                <span class="title"> State SL Tax:</span>
                <span>{{ coverages[state.coverage].surplusLineTax }}</span>
              </li>
              <li>
                <span class="title"> State Stamping Fee:</span>
                <span>{{ coverages[state.coverage].stampingFee }}</span>
              </li>
              <li>
                <span class="title">OREP Fee:  </span>
                <span>{{ coverages[state.coverage].orepFee }}</span>
              </li>
              <li>
                <span class="title">Extra Fee:</span>
                <span>{{ coverages[state.coverage].extraFee }}</span>
              </li>
              <li>
                <span class="title">Association Discount:</span>
                <span>-{{ coverages[state.coverage].discount }}</span>
              </li>
              <li v-if="ppiApplication.cyberTechnologyCoverage">
                <span class="title">Cyber :</span>
                <span>{{ coverages[state.coverage].premiumCyberTechnologyCoverage }}</span>
              </li>
              <li class="total">
              <span class="title">Total:</span>
                <h5 class="font-weight-bold m-0">{{ coverages[state.coverage].total }}</h5>
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title">General Aggregate Limit: </span>
                <span>{{ coverage_second_part() }}</span>
              </li>
              <li>
                <span class="title">Personal & Advertising Limit:</span>
                <span>{{ coverage_first_part() }}</span>
              </li>
              <li>
                <span class="title">Each Occurrence Limit:</span>
                <span>{{ coverage_first_part() }}</span>
              </li>
              <li>
                <span class="title">Damage to Premises Rented to You:</span>
                <span>$100,000</span>
              </li>
              <li>
                <span class="title">Business Personal Property:</span>
                <span>$25,000</span>
              </li>
              <li>
                <span class="title">Equipment Coverage:</span>
                <span>$15,000</span>
              </li>
              <li>
                <span class="title">
                  Computer Coverage:
                </span>
                <span>$5,000</span>
              </li>
            </ul>
          </div>
        </div>
      </article>
      <article v-else class="text-section table-section mt-5">
        <div class="row justify-content-md-center pt-4">
          <div class="col-md-8 mb-3 mt-3">
            <span class="text-center proposal-title" for="">
              <strong>Premium Proposal for: </strong> <span class=" blue-color"> {{ ppiApplication.nameOfApplicant }}</span>
            </span>
          </div>
          <div class="col-md-8 mb-3">
            <span class="col-md-4 text-center proposal-title pl-0 pr-0" for="">
              <strong>Limits of Coverage : </strong>
            <span class=" blue-color"> {{ coverage() }}</span>
            </span>
          </div>
        </div>
        <label v-if="getApplicantType==='Ermunro'" for="" class="text-justify" style="font-size: 25px">
          Thank you for submitting your application. Based on one or more answers, your application will need to be reviewed by an underwriter before we can present you with a premium proposal. Someone from ER MUNRO will reach out to you via email or phone within two business days. Thank you for shopping ER MUNRO!
        </label>

        <label v-else for="" class="text-justify" style="font-size: 25px">
          Thank you for submitting your application. Based on one or more answers, your application will need to be reviewed by an underwriter before we can present you with a premium proposal. Someone from OREP will reach out to you via email or phone within two business days. Thank you for shopping OREP!
        </label>

      </article>
      <article class="text-section table-section mt-5">
        <label for="" class="text-center font-weight-bold">
          Most Programs Do Not <em><strong>Specialize</strong></em> in Private Investigator Insurance and Defense. <span style="color:#A81508">We Do</span>. It Matters.
        </label>
        <div class="table-responsive">
          <table class="table-bordered mt-4 ">
            <thead>
              <th v-if="getApplicantType==='Ermunro'" width="60%" class="text-center font-weight-bold">Why Choose ER MUNRO?</th>
              <th v-else width="60%" class="text-center font-weight-bold">Why Choose OREP?</th>
              <th v-if="getApplicantType==='Ermunro'" width="20%" class="text-center font-weight-bold">Included with ER MUNRO</th>
              <th v-else width="20%" class="text-center font-weight-bold">Included with OREP</th>
              <th width="20%" class="text-center font-weight-bold">The Other Guys</th>
            </thead>
            <tbody>
              <tr>
                <td>
                  <label for="" class="red-text mb">
                    Attorney-Drafted Contracts
                  </label>
                  <label for="" class="table-text">
                    Enjoy an Attorney-drafted Engagement Letter template to use with your clients and an Indemnification Agreement template to use with Subcontractors you hire for your investigations.
                  </label>
                </td>
                <td>
                  <div>
                    <img src="../../../public/assets/images/shield1.png">
                  </div>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <label for="" class="red-text">
                    Specializing in PI Insurance and Risk Management
                  </label>
                  <label v-if="getApplicantType === 'Ermunro'" for="" class="table-text">
                    ER MUNRO does more than just offer insurance designed specifically for your business, we also specialize in PI risk management and provide you with professional support, contracts, and advice to help you limit your liability and stay out of trouble.
                  </label>
                  <label v-else for="" class="table-text">
                    OREP does more than just offer insurance designed specifically for your business, we also specialize in PI risk management and provide you with professional support, contracts, and advice to help you limit your liability and stay out of trouble.
                  </label>
                </td>
                <td>
                  <div>
                    <img src="../../../public/assets/images/shield1.png">
                  </div>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <label for="" class="red-text">
                    Business Building Benefits
                  </label>
                  <label v-if="getApplicantType==='Ermunro'" for="" class="table-text">
                    ER MUNRO Members enjoy a free 7 hour class on surveillance (approved for CE in most states), valuable business-building training guides, plus discounts with a variety of industryleading vendors.
                  </label>

                  <label v-else for="" class="table-text">
                    OREP Members enjoy a free 7 hour class on surveillance (approved for CE in most states), valuable business-building training guides, plus discounts with a variety of industryleading vendors.
                  </label>

                </td>
                <td>
                  <div>
                    <img src="../../../public/assets/images/shield1.png">
                  </div>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <label for="" class="red-text">
                    Coverage Designed Specifically For Private Investigators
                  </label>
                  <label v-if="getApplicantType==='Ermunro'" for="" class="table-text">
                    Your coverage isn’t generic. ER MUNRO’s policy is designed specifically for private investigators and contemplates the risks you face.
                  </label>
                  <label v-else for="" class="table-text">
                    Your coverage isn’t generic. OREP’s policy is designed specifically for private investigators and contemplates the risks you face.
                  </label>
                </td>
                <td>
                  <div>
                    <img src="../../../public/assets/images/shield1.png">
                  </div>
                </td>
                <td class="text-center">
                  <label class="text-center" for="">
                    Sometimes
                  </label>
                </td>
              </tr>
              <tr>
                <td>
                  <label for="" class="red-text">
                    Policy Includes E&O and General Liability Coverage in a Single Policy
                  </label>
                </td>
                <td>
                  <div>
                    <img src="../../../public/assets/images/shield1.png">
                  </div>
                </td>
                <td class="text-center">
                  <label class="text-center"  for="">
                    Rarely
                  </label>
                </td>
              </tr>
              <tr>
                <td>
                  <label for="" class="red-text">Personal Injury and Advertising Injury Coverage included at Base Policy at no charge</label>
                </td>
                <td>
                  <div>
                    <img src="../../../public/assets/images/shield1.png">
                  </div>
                </td>
                <td class="text-center">
                  <label class="text-center"  for="">
                    Almost Never
                  </label>
                </td>
              </tr>
              <tr>
                <td>
                  <label for="" class="red-text">
                    Guaranteed Delivery of Working PI
                  </label>
                  <label class="table-text"  for="">
                    Stay informed and “in-the-know” with a subscription to the most widely read trade publication in the private investigation profession.
                  </label>
                </td>
                <td>
                  <div>
                    <img src="../../../public/assets/images/shield1.png">
                  </div>
                </td>
                <td class="text-center">
                  <label class="text-center"  for="">
                    Definitely Not!
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </article>
      <article class="text-section table-section mt-5 mb-5">
        <label class="pt-4 text-center font-weight-bold blue-color w-100" for="">
          What Our Customers Say About Us:
        </label>
        <div class="row mt-4">
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">
            </div>
            <p class="review-wrapper">
              Requesting a quote, receiving a quote, and securing insurance was easy and seamless. My only regret is not having come here sooner. They have been recommended by my professional peers and will be so recommended by me as well. <br> <strong>Sharon P.</strong>
            </p>
          </div>
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">
            </div>
            <p v-if="getApplicantType==='Ermunro'" class="review-wrapper">
              Have used ER MUNRO for my E&O Insurance for nearly 2 decades. Always satisfied.<br><strong> Sandy W.</strong>
            </p>
            <p v-else class="review-wrapper">
              Have used OREP for my E&O Insurance for nearly 2 decades. Always satisfied.<br><strong> Sandy W.</strong>
            </p>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">
            </div>
            <p v-if="getApplicantType === 'Ermunro'" class="review-wrapper">
              Obtaining E&O insurance for my business from ER MUNRO is effortless. They have everything streamlined and are a pleasure to do business with.<br><strong> Jim C.</strong>
            </p>
            <p v-else class="review-wrapper">
              Obtaining E&O insurance for my business from OREP is effortless. They have everything streamlined and are a pleasure to do business with.<br><strong> Jim C.</strong>
            </p>
          </div>
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">
            </div>
            <p v-if="getApplicantType==='Ermunro'" class="review-wrapper">
              I’ve been getting my E&O through ERMUNRO for four years and they’re great! They send me reminders before my prior year ends, their prices are low and their customer service is very good with incredibly fast response. They provide extra value too with continuing education.<br><strong> Ed A.</strong>
            </p>
            <p v-else class="review-wrapper">
              I’ve been getting my E&O through OREP for four years and they’re great! They send me reminders before my prior year ends, their prices are low and their customer service is very good with incredibly fast response. They provide extra value too with continuing education.<br><strong> Ed A.</strong>
            </p>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">
            </div>
            <p v-if="getApplicantType==='Ermunro'" class="review-wrapper">
              I’ve been with ER MUNRO since I began and have no issues. If I call, I get to talk to a real live person! That’s important to me!<br> <strong>Jim K. </strong>
            </p>
            <p v-else class="review-wrapper">
              I’ve been with OREP since I began and have no issues. If I call, I get to talk to a real live person! That’s important to me!<br> <strong>Jim K. </strong>
            </p>

          </div>
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">
            </div>
            <p v-if="getApplicantType==='Ermunro'" class="review-wrapper">
              I have been with ER MUNRO almost 10 years and the service and rates have always been favorable. <br><strong>Otis A.</strong>
            </p>

            <p v-else class="review-wrapper">
              I have been with OREP almost 10 years and the service and rates have always been favorable. <br><strong>Otis A.</strong>
            </p>
          </div>
        </div>
      </article>
      <article>
        <div v-if="state.showPricing" class="row pt-5 mb-5 input-section text-center">
          <h5 class="text-center mx-auto">
            <span class="blue-color2 pr-1"><span></span>{{ ppiApplication.nameOfApplicant }} <span></span></span><strong> Enjoy Coverage Beginning:</strong><span class="blue-color2">{{ getEffectiveDate() }}</span>
          </h5>
        </div>
        <div v-if="state.showPricing" class="row mr-0 ml-0">
          <div class="col-md-7">
            <div class="text-center mr-5 pull-left">
              <p class="mr-0 representation-price-font-active">{{ coverages[state.coverage].total }}</p><span class="blue-color">Total - Pay in Full</span>
            </div>
            <button class="pull-right pay-now" @click="payNow(dollarSlicing(coverages[state.coverage].total))">PAY NOW</button>
          </div>
          <div class="col-md-5 quote-includes-btn-wrapper flex align-items-center justify-content-md-center">
            <button
              class="orep-select quote-include_2"
              name="state"
              v-validate="'required'"
            >
              Quote Includes
            </button>
          </div>
        </div>
        <div class="row quote-action quote-include_2-action-wrapper input-section mr-0 ml-0">
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title">Premium:</span>
                <span>{{ coverages[state.coverage].premium }}</span>
              </li>
              <li>
                <span class="title"> State SL Tax:</span>
                <span>{{ coverages[state.coverage].surplusLineTax }}</span>
              </li>
              <li>
                <span class="title"> State Stamping Fee:</span>
                <span>{{ coverages[state.coverage].stampingFee }}</span>
              </li>
              <li>
                <span class="title">OREP Fee:  </span>
                <span>{{ coverages[state.coverage].orepFee }}</span>
              </li>
              <li>
                <span class="title">Extra Fee:</span>
                <span>{{ coverages[state.coverage].extraFee }}</span>
              </li>
              <li>
                <span class="title">Association Discount:</span>
                <span>-{{ coverages[state.coverage].discount }}</span>
              </li>
              <li v-if="ppiApplication.cyberTechnologyCoverage">
                <span class="title">Cyber :</span>
                <span>{{ coverages[state.coverage].premiumCyberTechnologyCoverage }}</span>
              </li>
              <li class="total">
              <span class="title">Total:</span>
                <h5 class="font-weight-bold m-0">{{ coverages[state.coverage].total }}</h5>
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title">General Aggregate Limit: </span>
                <span>{{ coverage_second_part() }}</span>
              </li>
              <li>
                <span class="title">Personal & Advertising Limit:</span>
                <span>{{ coverage_first_part() }}</span>
              </li>
              <li>
                <span class="title">Each Occurrence Limit:</span>
                <span>{{ coverage_first_part() }}</span>
              </li>
              <li>
                <span class="title">Damage to Premises Rented to You:</span>
                <span>$100,000</span>
              </li>
              <li>
                <span class="title">Business Personal Property:</span>
                <span>$25,000</span>
              </li>
              <li>
                <span class="title">Equipment Coverage:</span>
                <span>$15,000</span>
              </li>
<!--              <li>-->
<!--                <span class="title">-->
<!--                  Computer Coverage:-->
<!--                </span>-->
<!--                <span>$5,000</span>-->
<!--              </li>-->
            </ul>
          </div>
        </div>
        <div v-if="state.showPricing"  class="row mr-0 ml-0 text-center" style="border-bottom: 1px solid #ccc">
          <div class="col-md-7">
            <div class="text-center mr-5 pull-left xxx-wrapper">
              <p class="mr-0 representation-price-font-disable">{{ coverages[state.coverage].downTotal }}</p>
            </div>
<!--            <a v-if="getApplicantType==='Ermunro'" target="_blank" v-bind:href="'https://orep.org/financehudson30-ermunro/index.php?name='+ ppiApplication.nameOfApplicant+'&ia_name='+ppiApplication.customer.contactName+'&address='+encodeURIComponent(ppiApplication.customer.address)+'&city='+ppiApplication.customer.city+'&state_code='+ppiApplication.customer.state+'&zip='+ppiApplication.customer.zipCode+'&phone='+ppiApplication.customer.phone+'&email='+ppiApplication.customer.email+'&date='+getEffectiveDate()+'&premium='+dollarSlicing(coverages[state.coverage].totalWithoutOrepFee)+'&orep_fee='+feeAfterDiscount(coverages[state.coverage].orepFee,coverages[state.coverage].discount)" class="pull-right pay-now_1">PAY NOW</a>-->

            <a v-if="ppiApplication.cyberTechnologyCoverage === false"
               v-bind:href="this.state.requestFinancingPaymentLinkWithOutCyberTechnology"
               target="_blank"
               class="pull-right pay-now_1">PAY NOW</a>

            <a v-else-if="ppiApplication.cyberTechnologyCoverage === true"
               v-bind:href="this.state.requestFinancingPaymentLinkWithCyberTechnology"
               target="_blank"
               class="pull-right pay-now_1">PAY NOW</a>

          </div>
          <div class="col-md-5 quote-includes-btn-wrapper flex align-items-center justify-content-md-center">
            <button
              class="orep-select quote-include_3"
              name="state"
              v-validate="'required'"
            >
              Quote Includes
            </button>
          </div>
        </div>
        <div class="row quote-action quote-include_3-action-wrapper input-section mr-0 ml-0">
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title">Premium:</span>
                <span>{{ coverages[state.coverage].premium }}</span>
              </li>
              <li>
                <span class="title"> State SL Tax:</span>
                <span>{{ coverages[state.coverage].surplusLineTax }}</span>
              </li>
              <li>
                <span class="title"> State Stamping Fee:</span>
                <span>{{ coverages[state.coverage].stampingFee }}</span>
              </li>
              <li>
                <span class="title">OREP Fee:  </span>
                <span>{{ coverages[state.coverage].orepFee }}</span>
              </li>
              <li>
                <span class="title">Extra Fee:</span>
                <span>{{ coverages[state.coverage].extraFee }}</span>
              </li>
              <li>
                <span class="title">Association Discount:</span>
                <span>-{{ coverages[state.coverage].discount }}</span>
              </li>
              <li v-if="ppiApplication.cyberTechnologyCoverage">
                <span class="title">Cyber :</span>
                <span>{{ coverages[state.coverage].premiumCyberTechnologyCoverage }}</span>
              </li>
              <li class="total">
              <span class="title">Total:</span>
                <h5 class="font-weight-bold m-0">{{ coverages[state.coverage].total }}</h5>
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title">General Aggregate Limit: </span>
                <span>{{ coverage_second_part() }}</span>
              </li>
              <li>
                <span class="title">Personal & Advertising Limit:</span>
                <span>{{ coverage_first_part() }}</span>
              </li>
              <li>
                <span class="title">Each Occurrence Limit:</span>
                <span>{{ coverage_first_part() }}</span>
              </li>
              <li>
                <span class="title">Damage to Premises Rented to You:</span>
                <span>$100,000</span>
              </li>
              <li>
                <span class="title">Business Personal Property:</span>
                <span>$25,000</span>
              </li>
              <li>
                <span class="title">Equipment Coverage:</span>
                <span>$15,000</span>
              </li>
<!--              <li>-->
<!--                <span class="title">-->
<!--                  Computer Coverage:-->
<!--                </span>-->
<!--                <span>$5,000</span>-->
<!--              </li>-->
            </ul>
          </div>
        </div>
        <div class="row pt-5 mb-5 input-section footer-wrapper">
          <h2 class="text-center mx-auto">
            <strong>Questions?</strong><a href="mailto:investigators@orep.org"> Email</a>, or Call Now (888) 347-5273.
          </h2>
        </div>
      </article>
    </section>
  </div>
</template>
<script>
import $ from "jquery";
import {APP_STATUS, STATES} from "../../utils/constants";
import {coverage} from "browserslist";
import moment from 'moment';

export default {
  name: "ppi-application-representation",
  data() {
    return {
      states: STATES
    };
  },
  computed: {
    ppiApplication() {
      return this.$store.state.ppiApplication.ppiApplication;
    },
    coverages() {
      return this.$store.state.ppiApplication.coverages;
    },
    state() {
      return this.$store.state.ppiApplication;
    },
    errorMsg() {
      return this.$store.state.ppiApplication.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/ppi-application-amba/' || this.ppiApplication.customer.partnerName === 'Mercer'){
        return 'Mercer';
      }else if (first === '/portal/ppi-application-realshield/' || this.ppiApplication.customer.partnerName === 'Realshield'){
        return 'Realshield';
      }
      else if (first === '/ermunro/ppi-application/' || first === '/ERMUNRO/ppi-application/' || this.ppiApplication.customer.partnerName === 'Ermunro'){
        return 'Ermunro';
      }
      else {
        return 'OREP';
      }
    },
  },

  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },

  methods: {
    totalAfterCyberTechnologyCoverage(coverages) {
      if (this.ppiApplication.cyberTechnologyCoverage) {
        coverages[this.$store.state.ppiApplication.coverage].total = coverages[this.$store.state.ppiApplication.coverage].totalWithCyberTechnologyCoverage
        coverages[this.$store.state.ppiApplication.coverage].totalWithoutOrepFee = coverages[this.$store.state.ppiApplication.coverage].totalWithCyberTechnologyCoverageWithoutOrepFee
        coverages[this.$store.state.ppiApplication.coverage].downTotal = coverages[this.$store.state.ppiApplication.coverage].downTotalWithCyberTechnologyCoverage
      }
      else{
        coverages[this.$store.state.ppiApplication.coverage].total = coverages[this.$store.state.ppiApplication.coverage].totalWithoutCyberTechnologyCoverage
        coverages[this.$store.state.ppiApplication.coverage].totalWithoutOrepFee = coverages[this.$store.state.ppiApplication.coverage].totalWithoutCyberTechnologyCoverageWithoutOrepFee
        coverages[this.$store.state.ppiApplication.coverage].downTotal = coverages[this.$store.state.ppiApplication.coverage].downTotalWithoutCyberTechnologyCoverage
      }
    },

    payNow(total) {
      // eslint-disable-next-line no-undef
      this.$store.state.ipfs.pageOneIsValid = true;
      this.$store.state.ipfs.premium = total;
      this.$store.state.ipfs.total = total;
      this.$store.state.ipfs.processingFee = (total * 0.019).toFixed(2);
      this.$store.state.ipfs.grandTotal = parseFloat(total) + parseFloat(this.$store.state.ipfs.processingFee);
      this.$store.state.ipfs.grandTotal = this.$store.state.ipfs.grandTotal.toFixed(2);

      if (this.getApplicantType === 'Ermunro'){
        this.$router.push({
          name: 'custom-payment-ermunro'
        });
      }
      else {
        this.$router.push({
          name: 'custom-payment-accelerant'
        });
      }
    },
    navigateToNext(routeName) {
      // eslint-disable-next-line no-undef
      this.$router.push({
        name: routeName
      });
    },
    getEffectiveDate() {
      return moment.utc(this.state.ppiApplication.effectiveDate).format('MM/DD/YYYY');
    },
    dollarSlicing(sclicingValue) {
      return sclicingValue.slice(1);
    },
    feeAfterDiscount(orepFee , discount) {
      return orepFee.slice(1) - discount.slice(1);
    },
    coverage() {
      switch (this.ppiApplication.limitsOfLiability[0]) {
        case '300K/600K':
          return '$300,000 / $600,000';
        case '500K/1M':
          return '$500,000 / $1,000,000';
        case '1M/3M':
          return '$1,000,000 / $3,000,000';
        default:
          return '$300,000 / $600,000';
      }
    },
    coverage_first_part() {
      switch (this.ppiApplication.limitsOfLiability[0]) {
        case '300K/600K':
          return '$300,000';
        case '500K/1M':
          return '$500,000';
        case '1M/3M':
          return '$1,000,000';
        default:
          return '$300,000';
      }
    },
    coverage_second_part() {
      switch (this.ppiApplication.limitsOfLiability[0]) {
        case '300K/600K':
          return '$600,000';
        case '500K/1M':
          return '$1,000,000';
        case '1M/3M':
          return '$3,000,000';
        default:
          return '$600,000';
      }
    },
    pageOneSubmit(routeName) {
      this.loading = true;
      this.ppiApplication.customer.contactName = this.state.ppiApplication.customer.contactName;
      this.ppiApplication.customer.companyName = this.state.ppiApplication.nameOfApplicant;
      this.ppiApplication.customer.isPpiApplication = 'True';
      this.ppiApplication.customer.appStatus = APP_STATUS.Partially_Completed;
      if (this.getApplicantType === 'Mercer'){
        this.ppiApplication.customer.partnerName = 'Mercer';
      }
      else if (this.getApplicantType === 'Realshield'){
        this.ppiApplication.customer.partnerName = 'Realshield';
      }
      else if (this.getApplicantType === 'Ermunro'){
        this.ppiApplication.customer.partnerName = 'Ermunro';
      }

      this.$store.dispatch('ppiApplication/createCustomer');

      // this.$router.push({
      //   name: routeName,
      // });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    }
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted: function() {
      $(".orep-select.quote-include").click(function(){
        if($(this).hasClass("active")){
          $(this).removeClass("active");
          $(".quote-include-action-wrapper").css("padding-top", "0px");
          $(".quote-include-action-wrapper").css("height", "0px");
          $(".quote-include-action-wrapper").css("opacity", "0");
        }else{
          $(this).addClass("active");
          $(".quote-include-action-wrapper").css("padding-top", "40px");
          $(".quote-include-action-wrapper").css("height", "330px");
          $(".quote-include-action-wrapper").css("opacity", "1");
        }
      }),
      $(".orep-select.quote-include_1").click(function(){
        if($(this).hasClass("active")){
          $(this).removeClass("active");
          $(".quote-include_1-action-wrapper").css("padding-top", "0px");
          $(".quote-include_1-action-wrapper").css("height", "0px");
          $(".quote-include_1-action-wrapper").css("opacity", "0");
        }else{
          $(this).addClass("active");
          $(".quote-include_1-action-wrapper").css("padding-top", "40px");
          $(".quote-include_1-action-wrapper").css("height", "330px");
          $(".quote-include_1-action-wrapper").css("opacity", "1");
        }
      }),
      $(".orep-select.quote-include_2").click(function(){
        if($(this).hasClass("active")){
          $(this).removeClass("active");
          $(".quote-include_2-action-wrapper").css("padding-top", "0px");
          $(".quote-include_2-action-wrapper").css("height", "0px");
          $(".quote-include_2-action-wrapper").css("opacity", "0");
        }else{
          $(this).addClass("active");
          $(".quote-include_2-action-wrapper").css("padding-top", "40px");
          $(".quote-include_2-action-wrapper").css("height", "330px");
          $(".quote-include_2-action-wrapper").css("opacity", "1");
        }
      }),
      $(".orep-select.quote-include_3").click(function(){
        if($(this).hasClass("active")){
          $(this).removeClass("active");
          $(".quote-include_3-action-wrapper").css("padding-top", "0px");
          $(".quote-include_3-action-wrapper").css("height", "0px");
          $(".quote-include_3-action-wrapper").css("opacity", "0");
        }else{
          $(this).addClass("active");
          $(".quote-include_3-action-wrapper").css("padding-top", "40px");
          $(".quote-include_3-action-wrapper").css("height", "330px");
          $(".quote-include_3-action-wrapper").css("opacity", "1");
        }
      });
      const params = this.$route.query;
      if (params && params.filter) {
        this.state.ppiApplication.applicantRequestFrom = params.filter;
      }
      $('html, body').animate({
        scrollTop: $('.page-container').offset().top
      }, 500);
    },
};
</script>
<style scoped>
.coverage-link {
  text-decoration: none;
  font-weight: bold;
  font-family: Roboto, sans-serif;
  color: #046085;
}

.coverage-link:hover {
  text-decoration: underline;
}
</style>